import { StrategyStore } from './StratProject/StrategyStore';
import { ArticlesStore } from './PortfolioProject/ArticlesStore';
import { IncomeProjStore } from './PortfolioProject/IncomeProjStore';

export class MainStore {
  constructor() {
    this.strategies = new StrategyStore();
    this.articles = new ArticlesStore();
    this.incomeProj = new IncomeProjStore();
  }
}
